// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__RUiDv","disabled":"FileBtn_disabled__3IJic","warn":"FileBtn_warn__36wk1","fade":"FileBtn_fade__2I1K-"};